<!--
 * @Author: DY
 * @Date: 2024-12-05 17:50:23
 * @LastEditTime: 2026-07-06 13:16:45
 * @Description: 物资领用审核表单
 * @FilePath: \ShiMoMobile\src\views\storage\materialRequisitionReview\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="materialRequisitionReviewForm commonFormStyles">
            <HeaderNav
                v-if="!isNews"
                header-title="物资领用审核表"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-tabs class="currencyTabsStyle" v-model="activeTab" animated :scrollspy="false">
                    <van-tab title="申请信息表">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>申请信息表</h5>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="物资领用出库单号"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.OutstockNumber"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="领用单位"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_4@2x.png')"
                                        v-model="formData.ManageOrgName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="领用部门"
                                        placeholder="选择领用部门"
                                        :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                                        v-model="formData.DeptName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="申请人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.ApplyUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="申请时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.ApplyTime"
                                    ></van-field>
                                </li>
                                <!-- <li>
                                    <van-field
                                        name="radio"
                                        label="领用类型"
                                        class="fieldRadio"
                                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                    >
                                        <template #input>
                                            <van-radio-group v-model="formData.Type" direction="horizontal" disabled>
                                                <van-radio :name="0" checked-color="#ee0a24">
                                                    备品备件
                                                </van-radio>
                                                <van-radio :name="1" checked-color="#ee0a24">
                                                    办公用品
                                                </van-radio>
                                            </van-radio-group>
                                        </template>
                                    </van-field>
                                </li> -->
                                <li>
                                    <van-field
                                        disabled
                                        label="领用部门负责人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.ManageName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="部门负责人审核时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.ManageTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="仓库名称"
                                        placeholder="选择仓库"
                                        :left-icon="require('@/assets/images/icons/icon_47@2x.png')"
                                        v-model="formData.StockName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="库管员"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.OutstockUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        readonly
                                        label="出库类型"
                                        :placeholder="isDisabled ? '' : '请选择出库类型'"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="formData.OutstockTypeName"
                                        @click="selectOutstockType"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="状态"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="Status"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.OutstockTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        label="备注"
                                        type="textarea"
                                        :rows="2"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                        v-model="formData.Remarks"
                                    ></van-field>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="申请明细表">
                        <div class="formList van-pull-refresh">
                            <ul v-for="(item, index) in formData.Materials" class="formItem" :key="`outboundDetails_${index}`">
                                <li class="formItemTitle">
                                    <h5>物料代码: {{ item.MaterialCode }}</h5>
                                </li>
                                <li>
                                    <van-cell
                                        title="短描述"
                                        :value="item.MaterialShortName"
                                        :icon="require('@/assets/images/icons/icon_28@2x.png')"
                                    ></van-cell>
                                </li>
                                <li>
                                    <van-cell
                                        title="长描述"
                                        :value="item.MaterialName"
                                        :icon="require('@/assets/images/icons/icon_10@2x.png')"
                                    ></van-cell>
                                </li>
                                <li>
                                    <van-cell
                                        title="申请出库数量"
                                        :value="item.VolumeOutstock"
                                        :icon="require('@/assets/images/icons/icon_6@2x.png')"
                                    ></van-cell>
                                </li>
                                <li>
                                    <van-cell
                                        title="单位"
                                        :value="item.Unit"
                                        :icon="require('@/assets/images/icons/icon_2@2x.png')"
                                    ></van-cell>
                                </li>
                                <li>
                                    <van-cell
                                        title="成本中心"
                                        :value="item.CostCenter"
                                        :icon="require('@/assets/images/icons/icon_26@2x.png')"
                                    ></van-cell>
                                </li>
                                <li class="materialItem" v-for="(k, j) in item.Splits" :key="`warehouseLocation_${j}`">
                                    <van-cell :icon="require('@/assets/images/icons/icon_3@2x.png')">
                                        <template #title>
                                            <span class="custom-title">存放位置</span>
                                            <button type="button" class="vanCellBtn" v-if="!isDisabled && j === item.Splits.length - 1" @click="splitClick(item.Splits)">
                                                拆分
                                            </button>
                                            <button type="button" class="vanCellBtn" v-if="!isDisabled" @click="deleteClick(item.Splits, j)">
                                                删除
                                            </button>
                                        </template>
                                        <template #default>
                                            <span class="custom-title">{{ k.GridName }}</span>
                                        </template>
                                        <template #right-icon v-if="!isDisabled">
                                            <button type="button" class="vanCellBtn" @click="selectWarehouseLocation(item, k)">
                                                选择库位
                                            </button>
                                        </template>
                                    </van-cell>
                                    <ol>
                                        <li>
                                            <h4>实际出库量：</h4>
                                            <input type="text" :disabled="isDisabled" v-model="k.VolumePractical" @change="volumePracticalInput(item, k)">
                                        </li>
                                        <li>
                                            <h4>出库前库存：</h4>
                                            <input type="text" disabled v-model="k.VolumeBefore">
                                        </li>
                                        <li>
                                            <h4>出库后库存：</h4>
                                            <input type="text" disabled v-model="k.VolumeAfter">
                                        </li>
                                    </ol>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                </van-tabs>
                <van-action-sheet title="选择出库类型" v-model="showOutstockType" :actions="outstockTypeList" cancel-text="取消" @select="selectOutstockTypeConfirm" :style="{maxHeight: '50%'}"></van-action-sheet>
            </section>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <template v-if="formData.Status != 1 && (formData.Status == 3 && formData.Type == 0)">
                        <button class="confirm" @click="confirmForm">
                            扫码确认
                        </button>
                    </template>
                    <button class="confirm" @click="saveForm">
                        保存
                    </button>
                    <template v-if="formData.Status != 3">
                        <button class="confirm" @click="notApprovedForm">
                            不通过
                        </button>
                        <button class="confirm" @click="adoptForm">
                            通过
                        </button>
                    </template>
                    <!-- <template v-if="formData.Status == 3 && formData.Type == 1">
                        <button class="confirm" @click="confirmOutbound">
                            确认出库
                        </button>
                    </template> -->
                    <template v-if="formData.Status == 3">
                        <button class="confirm" @click="toVoidForm">
                            作废
                        </button>
                    </template>
                </template>
                <template v-if="!isNews">
                    <button class="confirm" @click="closeAllocationForm">
                        关闭
                    </button>
                </template>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { mixin_MessageJump } from '@/assets/mixin/mixin_MessageJump';
import { mixin_outboundTypeSelect } from '@/assets/mixin/mixin_outboundTypeSelect';
import { HeaderNav } from '@/components/';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    name: 'material-requisition-review-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/materialRequisitionReview') {
            this.$store.commit('noKeepAlive', 'material-requisition-review-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    mixins: [mixin_MessageJump, mixin_outboundTypeSelect],
    props: {},
    data() {
        return {
            isDisabled: false,
            activeTab: 0,
            formData: {},
            Status: '',
            currentMaterials: {},
            currentStorageLocation: {},
            isNews: false,

            material_category: 1,
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.WarehouseLocation) {
            this.currentStorageLocation.GridId = this.$route.params.WarehouseLocation[0].grid_id;
            this.currentStorageLocation.GridCode = this.$route.params.WarehouseLocation[0].grid_code;
            this.currentStorageLocation.GridName = this.$route.params.WarehouseLocation[0].grid_name;
            this.currentStorageLocation.VolumeBefore = this.$route.params.WarehouseLocation[0].volume_current;

            if ((this.currentMaterials.Splits || []).length === 1) {
                this.currentStorageLocation.VolumePractical = this.currentMaterials.VolumeOutstock;
                this.currentStorageLocation.VolumeAfter = NP.minus(
                    this.currentStorageLocation.VolumeBefore || 0,
                    this.currentStorageLocation.VolumePractical || 0
                );
            }
        }
    },
    created() {
        this.initpage();
    },
    methods: {
        // 右划回退
        swiperright() {
            if (!this.isNews) {
                this.$router.isBack = 1;
                this.$router.go(-1);
            }
        },

        async initpage() {
            window.jyCallback_DriveScanFinished = this.jyCallback_DriveScanFinished_wzlysh;
            this.isNews = this.$route.params.isNews || false;
            if (this.isNews && this.$route.params.data.tenant_id) {
                // 有tenant_id，消息列表跳转办理页面，判断多租户
                await this.getNewsToken(this.$route.params.data.tenant_id);
            }
            const type = this.$route.params.type;
            if (type === 'see') {
                this.isDisabled = true;
            }
            this.formData = await this.getFormData(this.$route.params.data.id);

            this.formData.Materials.forEach(item => {
                item.Splits.forEach(k => {
                    if (k.VolumePractical === null || k.VolumePractical === 'null') {
                        k.VolumePractical = item.VolumeOutstock;
                        k.VolumeAfter = NP.minus(k.VolumeBefore || 0, k.VolumePractical || 0);
                    }
                });
            });

            this.Status = this.loadStatus(this.formData.Status);

            if (this.formData.ApplyDeptId !== this.formData.DeptId) {
                this.$dialog.alert({
                    message: '领用申请人和物资领用审核人不属于同一部门，请注意！',
                    theme: 'round-button',
                });
            }
        },

        loadStatus(nub) {
            const staus = ['待提交', '待审核', '未通过', '待出库', '已出库', '已作废'];
            return staus[nub];
        },

        splitClick(GridDetails) {
            GridDetails.push({
                GridId: '',
                GridCode: '',
                GridName: '',
                VolumePractical: '',
                VolumeBefore: '',
                VolumeAfter: '',
            });
        },

        deleteClick(Splits, index) {
            if (Splits.length === 1) {
                this.$set(Splits, 0, {
                    GridId: '',
                    GridCode: '',
                    GridName: '',
                    VolumePractical: '',
                    VolumeBefore: '',
                    VolumeAfter: '',
                });
            } else {
                Splits.splice(index, 1);
            }

        },

        // 选择库位
        async selectWarehouseLocation(item, k) {
            if (this.isDisabled) { return; }
            this.currentMaterials = item;
            this.currentStorageLocation = k;
            const gridIds = item.Splits.map(item => item.GridId).toString();
            const verify = await this.verifyStorageLocation(gridIds, item.MaterialCode);
            if (!verify) {
                this.$toast.fail('没有多余的库位！');
            } else {
                this.$router.isBack = 2;
                this.$router.replace({
                    name: 'selectTable',
                    params: {
                        newsToken: this.newsToken,
                        sourcePath: 'materialRequisitionReviewForm',
                        listCode: 'outstock_select_grid',
                        callbackDataKey: 'WarehouseLocation',
                        requestUrl: `/basicplatform/tabledata?material_code=${item.MaterialCode}&stock_id=${item.StockId}&grid_ids=${gridIds}`,
                        relationKey: 'grid_id',
                        indexKey: 'page',
                        sizeKey: 'limit',
                        pageIndex: 0,
                        initIndex: 0,
                        headerList: [{
                            name: '库位编码',
                            code: 'grid_code',
                        }, {
                            name: '库位名称',
                            code: 'grid_name',
                        }, {
                            name: '当前库存',
                            code: 'volume_current',
                        }],
                    },
                });
            }
        },

        volumePracticalInput(item, k) {
            if (k.GridCode === '') {
                this.$toast.fail('请选择库位！');
                k.VolumePractical = null;
                return;
            }
            let nubs = 0;
            item.Splits.forEach(z => {
                nubs = NP.plus(nubs || 0, z.VolumePractical || 0);
            });
            // if (nubs > item.VolumeOutstock) {
            //     this.$toast.fail('实际出库数量大于申请出库数量，请重新输入！');
            //     this.$nextTick(() => {
            //         this.$set(k, 'VolumePractical', 0);
            //         this.$set(k, 'VolumeAfter', NP.minus(k.VolumeBefore || 0, k.VolumePractical || 0));
            //     });
            // } else {
            //     this.$set(k, 'VolumeAfter', NP.minus(k.VolumeBefore || 0, k.VolumePractical || 0));
            // }
            if (nubs > item.VolumeOutstock) {
                this.$toast.fail('实际出库数量大于申请出库数量，请重新输入！');
            }
            this.$set(k, 'VolumeAfter', NP.minus(k.VolumeBefore || 0, k.VolumePractical || 0));
        },

        async saveForm() {
            const res = await this.saveFormDataRequest(this.formData);
            if (res) {
                this.$toast.success('保存成功。');
            }
        },

        async notApprovedForm() {
            const res = await this.notApprovedRequest(this.formData.Id);
            if (res) {
                this.$toast.fail('审核不通过。');
                this.closeAllocationForm();
            }
        },

        toVoidForm() {
            this.$dialog.confirm({
                title: '提示',
                message: '是否作废此领用出库单？',
            }).then(async () => {
                const res = await this.toVoidRequest(this.formData.Id);
                if (res) {
                    this.$toast.success('作废成功。');
                    this.closeAllocationForm();
                }
            });
        },

        async adoptForm() {
            const res = await this.adoptRequest(this.formData.Id);
            if (res) {
                this.$toast.success('审核通过。');
                this.closeAllocationForm();
            }
        },
        async confirmForm() {
            if (this.formData.Status === 3 && (this.formData.OutstockTypeCode || '') === '') {
                this.$toast.fail('请选择出库类型！');
                return;
            }
            try {
                await this.saveFormDataRequest(this.formData);
                this.$callMobile('JYExternalNative', 'jyDriveScanClick');
            } catch (error) {
                this.$toast(error.ErrorCode.Message);
            }
        },
        async jyCallback_DriveScanFinished_wzlysh(val) {
            if (this.formData.OutstockNumber === val) {
                try {
                    await this.outboundRequest(this.formData.Id);
                    this.$toast.success('出库完成。');
                    this.closeAllocationForm();
                } catch (error) {
                    this.$toast(error.ErrorCode.Message);
                }
            } else {
                this.$toast.fail('物资领用不匹配！');
            }
        },

        async confirmOutbound() {
            try {
                await this.outboundRequest(this.formData.Id);
                this.$toast.success('出库完成。');
                this.closeAllocationForm();
            } catch (error) {
                this.$toast(error.ErrorCode.Message);
            }
        },

        closeAllocationForm() {
            if (!this.isNews) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: 'materialRequisitionReview',
                    params: {
                        saveCallback: true,
                    },
                });
            } else {
                this.isDisabled = true;
            }
        },

        verifyStorageLocation(grid_ids, material_code) {
            return this.$axios.$get(`/interfaceApi/procurement/outstock/can_detachable?grid_ids=${grid_ids}&material_code=${material_code}&stock_id=${this.formData.StockId}`, { token: this.newsToken });
        },
        getFormData(id) {
            return this.$axios.$get(`/interfaceApi/procurement/outstock/${id}`, { token: this.newsToken });
        },
        saveFormDataRequest(requestData) {
            return this.$axios.$post('/interfaceApi/procurement/outstock/change', requestData, { token: this.newsToken });
        },
        adoptRequest(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock/check/${id}`, {}, { token: this.newsToken });
        },
        notApprovedRequest(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock/check_no/${id}`, {}, { token: this.newsToken });
        },
        toVoidRequest(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock/cancel/${id}`, {}, { token: this.newsToken });
        },
        outboundRequest(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock/outstock/${id}`, {}, { token: this.newsToken });
        },
    },
};
</script>
<style lang="stylus">
.materialRequisitionReviewForm
    background #F0F0F0
    section
        flex 1
        height 0
        .van-tabs__content
            .van-tab__pane
                max-height initial
                height 100%
                overflow-y hidden
    .formList
        padding 10rpx
        .materialItem
            border-bottom: 1px solid #f0f0f0
            ol
                display: flex
                padding 5rpx 7rpx 14rpx 7rpx
                background: #fff
                li
                    flex 1
                    padding: 0 7rpx
                    h4
                        font-size 14rpx
                        color #626262
                        margin-bottom: 7rpx
                    input
                        width 100%
                        height 36rpx
                        border 1px solid #D7D7D7
                        border-radius: 4rpx
                        font-size 12rpx
                        padding: 0 10rpx
</style>
